<template>
    <div class="paper-create-content">
        <el-scrollbar class="main-content">
            <el-breadcrumb class="genera-breadcrumb" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>组卷概率</el-breadcrumb-item>
                <el-breadcrumb-item>创建概率模板</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="select-wrapper">
                <div class="select-box">
                    <div class="select-name">模板名称</div>
                    <div class="select-left">
                        <el-input v-model="paper_per_group_name" ref="paper_per_group_name" style="width: 300px"
                                  placeholder="2-18个字" size="medium"
                                  minlength="2" maxlength="18" @change="checkName"></el-input>
                    </div>
                </div>
                <div class="select-box">
                    <div class="select-name">选择试题分类</div>
                    <div class="select-left">
                        <el-cascader v-if="courseClassValue.length > 0" v-model="courseClassValue" style="width: 300px" size="medium" :props="keyObj"
                                     :options="courseClass" ref="specObj" clearable placeholder="一级分类/二级分类"
                                     @change="changeCourseClass"></el-cascader>
                        <el-cascader v-else v-model="courseClassValue" style="width: 300px" size="medium" :props="keyObj"
                                     :options="courseClass" ref="specObj" clearable placeholder="全部"
                                     @change="changeCourseClass"></el-cascader>
                    </div>
                </div>
            </div>
            <el-table :data="paperData" height="1%" size="medium"
                      :header-cell-style="{fontWeight: 'normal', color: '#666', background: '#F6F6F6', height:'60px'}"
                      class="customTable" :cell-style="{fontSize: '16px',color: '#333', height:'70px'}">
                <el-table-column label="三级分类">
                    <template slot-scope="scope">
                        <span class="text-overflow-2"
                              :title="scope.row.category_name">{{ scope.row.category_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="全部使用" width="500" align="left">
                    <template slot="header" slot-scope="scope">
                        <div class="head-content">
                            <span class="head-text">概率</span>
                            <el-input size="medium" v-model="search" @change="changeAll"/>
                            %
                            <span class="head-text-right">全部使用</span>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="inner-box">
                            <el-input size="medium" v-model="scope.row.per"/>
                            %
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="foot-wrapper">
                <el-button type="primary" @click="submitForm">创建</el-button>
                <el-button @click="goBack">返回</el-button>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
    import {probabilityGetDetail, probabilityEdit} from '@/utils/apis';

    export default {
        name: "paperCreate",
        data() {
            return {
                paper_per_group_name: '',
                courseClassValue: [],
                courseClass: [],
                keyObj: {
                    label: 'category_name',
                    value: 'category_id',
                    children: 'children'
                },
                paperData: [],
                search: '',
                id:this.$route.query.id,
            }
        },
        created() {
            this.getCategoryList();
        },
        methods: {
            getCategoryList() {
                if (this.id != undefined) {
                    let param = {
                        paper_per_group_id: this.id
                    }
                    probabilityGetDetail(param).then((res) => {
                        if (res.code == 200) {
                            this.courseClass = res.data.category_data;
                            this.paperData = res.data.list;
                            this.paper_per_group_name = res.data.paper_per_group_name
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                } else {
                    probabilityGetDetail().then((res) => {
                        if (res.code == 200) {
                            this.courseClass = res.data.category_data;
                            this.paperData = res.data.list;
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            checkName() {
                let arr = this.paper_per_group_name.split('');
                if (arr.length < 2) {
                    this.$refs.paper_per_group_name.$el.classList.add('isError');
                    return 1
                } else {
                    this.$refs.paper_per_group_name.$el.classList.remove('isError');
                    return 0
                }
            },
            changeAll() {
                this.paperData.forEach(item => {
                    item.per = this.search
                })
            },
            submitForm() {
                console.log(this.paperData, 999)
                let isErrNum = 0;
                let arr = [];
                isErrNum = this.checkName();
                if (isErrNum == 0) {
                    this.paperData.forEach(item => {
                        let obj = {
                            category_id: item.category_id,
                            per: item.per
                        }
                        arr.push(obj)
                    })
                    console.log(arr)
                    let param = {
                        paper_per_group_name: this.paper_per_group_name,
                        paper_per_data: JSON.stringify(arr)
                    }
                    if (this.id != undefined) {
                        param.paper_per_group_id = this.id
                    }
                    probabilityEdit(param).then((res) => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.goBack();
                        }
                    })
                }
            },
            goBack() {
                this.$router.push('/paperProbability/index')
            },
            changeCourseClass() {
                let second_id = this.courseClassValue[this.courseClassValue.length - 1]
                let param = {
                    second_id: second_id
                }
                if (this.id != undefined){
                    param.paper_per_group_id = this.id
                }
                probabilityGetDetail(param).then((res) => {
                    if (res.code == 200) {
                        this.paperData = res.data.list
                    }
                }).catch((err) => {
                    console.log(err);
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .paper-create-content {
        height: 100%;
        display: flex;
        flex-direction: column;

        .main-content {
            flex: 1;
            height: 100%;
        }

        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        ::v-deep .el-scrollbar__view {
            padding: 0 20px;
            height: 100%;
            display: flex;
            flex-direction: column;
        }

        .select-wrapper {
            margin-top: 15px;
            display: flex;

            .select-box {
                display: flex;
                align-items: center;
                margin-right: 30px;

                .select-left {
                    margin-left: 12px;
                }
            }
        }

        .customTable {
            margin-top: 15px;
            margin-bottom: 60px;
            flex: 1;

            .el-input {
                width: 72px;
                margin: 0 10px;
            }

            .head-content {
                display: flex;
                align-items: center;

                .head-text-right {
                    margin-left: 8px;
                }
            }

            .inner-box {
                padding-left: 28px;
            }
        }

        .foot-wrapper {
            margin-bottom: 60px;
            text-align: center;

            .el-button + .el-button {
                margin-left: 20px;
            }
        }
    }
</style>